export function roundRobin(current: number, maximum: number): number {
  return current < maximum - 1 ? current + 1 : 0;
}
